module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.a0d13d16.woff";